import {showLog} from '../logger';

const Evented = Object.preventExtensions({
  on()      {window.$(this).on(...arguments);},
  one()     {window.$(this).one(...arguments);},
  off()     {window.$(this).off(...arguments);},
  trigger() {
    showLog('Evented::trigger', ...arguments);
    window.$(this).trigger(...arguments);
  }
});

export default Evented;



// WEBPACK FOOTER //
// ./src/mixins/evented.js